<template>
  <a-layout>
    <Breadcrumb />
    <div class="page-title-container">
      <span class="page-title">待评估列表</span>
    </div>
    <div class="content-container">
      <div class="search-container">
        <a-input placeholder="输入项目名称搜索" v-model="searchParams.projectName" class="medium-search-input">
          <a-icon slot="prefix" type="search" />
        </a-input>
        <a-cascader placeholder="所在区域" :options="regionOptions" v-model="searchParams.regionIds" change-on-select style="width:240px;margin-right: 20px"  />
        <a-button
            @click="onSearch"
            class="search-btn"
        >搜索</a-button
        >
      </div>
      <div class="list-container">
        <a-table
            :columns="tblColumns"
            :data-source="tblData"
            :pagination="pagination"
            :loading="loading"
            class="data-table"
            rowKey="projectId"
            @change="onTableChange"
        >
          <a-space slot="action" slot-scope="record">
            <a @click="onRiskReview(record)">开始评估</a>
            <a-divider v-if="record.metricZip!=null && record.metricZip!=''" type="vertical" />
            <a v-if="record.metricZip!=null && record.metricZip!=''" :href="record.metricZip" target="_blank">资料下载</a>
          </a-space>
          <div slot="completePercent" slot-scope="record" class="small-text">
            {{ record.completePercentage }} %
          </div>
        </a-table>
      </div>
    </div>
  </a-layout>
</template>

<script>
import Breadcrumb from "@/components/Breadcrumb.vue";
import { tsFormat } from "@/components/DateUtils";
import { listRiskReviewProjects } from "@/services/DocService";
import {baseURL} from "@/services/HttpService";
import { regionOptions } from "@/geo/region";

const tblColumns = [
  {
    title: "项目名称",
    dataIndex: "projectName",
    width: "15%"
  },
  {
    title: "所在区域",
    dataIndex: "regionFullName",
    width: "8%"
  },
  {
    title: "状态",
    dataIndex: "overallStatus",
    width: "6%"
  },
  {
    title: "提交人",
    dataIndex: "submitUserName",
    width: "6%"
  },
  {
    title: "提交时间",
    dataIndex: "submitTime",
    width: "10%"
  },
  {
    title: "复核人",
    dataIndex: "analystName",
    width: "8%"
  },
  {
    title: "复核时间",
    dataIndex: "assessTime",
    width: "10%"
  },
  {
    title: "操作",
    key: "action",
    scopedSlots: {customRender: "action"},
    width: "15%",
  }
];

export default {
  components: { Breadcrumb },
  data() {
    return {
      form: this.$form.createForm(this, { name: "searchForm" }),
      tblColumns,
      tblData: [],
      regionOptions,
      pagination: {
        showQuickJumper: true
      },
      searchParams: {
        projectName: "",
        regionIds:[]
      },
      loading: false,
      viewUrl: baseURL + "/attachment?fileName=",
    };
  },
  computed: {
  },
  mounted() {
    this.fetchList();
  },
  methods: {
    onTableChange(p) {
      this.fetchList(p.current, p.pageSize);
    },
    onSearch() {
      this.fetchList();
    },
    onReset() {
      this.searchParams.projectName = "";
      this.fetchList();
    },
    fetchList(pageNum = 1, pageSize = 10) {
      let params = {
        ...this.searchParams,
        pageNum,
        pageSize
      };
      params.state = '已提交';

      listRiskReviewProjects(params)
          .then(response => {
            this.loading = false;
            if (response.data.code === "FAILED") {
              console.log("服务端错误", response.data.errorMsg);
              this.$message.error("读取数据失败");
            } else {
              this.setTblData(response);
            }
          });
    },
    setTblData(response) {
      let buzData = response.data.data;
      let rltList = buzData.records;
      if (rltList) {
        rltList.forEach(item => {
          if (item.createTime) {
            item.createTime = tsFormat(item.createTime);
          }
          if(item.submitTime) {
            item.submitTime = tsFormat(item.submitTime);
          }
          if(item.assessTime) {
            item.assessTime = tsFormat(item.assessTime);
          }
          if(item.metricZip) {
            item.metricZip = this.viewUrl + item.metricZip;
          }
        });
      }
      this.tblData = rltList;
      const pagination = { ...this.pagination };
      pagination.current = buzData.pageNum;
      pagination.total = buzData.total;
      pagination.pageSize = buzData.pageSize;
      pagination.showTotal = function (total, range) {
        return `当前显示 ${range[0]} - ${range[1]} 条, 共 ${total} 条`;
      };
      this.pagination = pagination;
    },
    onRiskReview(record) {
      this.$router.push({path: `/adm/risk-review/${record.projectId}`});
    },
  }
};
</script>

<style scoped>

</style>
